import { useEffect, useState } from "react";
import { animate, useMotionValue, useTransform, AnimatePresence, motion } from "motion/react";

import {
    Box,
    Typography,
    Paper,
    Tabs,
    Tab,
    Chip,
    Stack,
    Button,
} from "@mui/material";

import {
    SavingsOutlined,
    TrendingUpOutlined,
    DescriptionOutlined,
    AccountBalanceWalletOutlined,
} from "@mui/icons-material";

import { getUser } from "../../utils/auth";
import PrimerAccesoModal from "./PrimerAccesoModal";
import { Flip, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { toast_config } from "../toastify/config";
import { jwtDecode } from "jwt-decode";
import apiRc from "../../axios/axios";
import TablaAhorrador from "./TablaAhorrador";
import TablaInversionista from "./TablaInversionista";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";

const ClientesHome = () => {
    const [usuario, setUsuario] = useState(null);
    const [mostrarPrimerAcceso, setMostrarPrimerAcceso] = useState(false);
    const [tab, setTab] = useState(0);
    const [contratosActivos, setContratosActivos] = useState(0)
    const [contratosAhorro, setContratosAhorro] = useState(0)
    const [contratosInversor, setContratosInversor] = useState(0)
    const [contratosAhorrador, setContratosAhorrador] = useState([]);
    const [contratosInversionista, setContratosInversionista] = useState([]);

    const navigate = useNavigate();

    const obtenerContratos = () => {

        const cargarContratos = async () => {

            try {

                const token = sessionStorage.getItem("token");

                const decoded = jwtDecode(token);

                const { data } = await apiRc.get(`/obtener-contratos-ahorrador/${btoa(decoded.id_ahorrador)}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                });
                //console.log(data)
                const contratosActivosNumero = data.contratosAhorrador?.length + data.contratosInversor?.length
                const contratosAhorradoNumero = data.contratosAhorrador?.length ?? 0
                const contratosInversionNumero = data.contratosInversor?.length ?? 0

                setContratosActivos(contratosActivosNumero)
                setContratosAhorro(contratosAhorradoNumero)
                setContratosInversor(contratosInversionNumero)
                setContratosAhorrador(data.contratosAhorrador);
                setContratosInversionista(data.contratosInversor);

            } catch (error) {
                console.log(error);

                let msg_error = "";

                if (error.response) {

                    if (error.response.data?.mensaje) {
                        msg_error = error.response.data.mensaje;
                    } else {
                        msg_error = "Ocurrió un error al iniciar sesión, favor de volver a intentarlo.";
                    }

                } else {
                    msg_error = "No hay respuesta por parte del servidor.";
                }

                toast.error(msg_error, toast_config);
            }

        }

        cargarContratos()

    }

    useEffect(() => {
        const usuarioToken = getUser();

        setUsuario(usuarioToken);

        if (usuarioToken?.primer_acceso === false) {
            setMostrarPrimerAcceso(true);
        }

        //buscar los contratos de ahorro y de inversion, mostrarlos en la tabla y agregar boton de cerrar sesion
        //poner la opcion de firmar contrato, si ya esta firmado poder ver el contrato

        obtenerContratos()

    }, []);

    const passwordActualizada = () => {
        const nuevoUsuario = getUser();

        setUsuario(nuevoUsuario);
        setMostrarPrimerAcceso(false);
    };

    const handleChangeTab = (_, newValue) => {
        setTab(newValue);
    };

    const NumeroAnimado = ({ valor }) => {
        const count = useMotionValue(0);

        const rounded = useTransform(count, (latest) =>
            Math.round(latest)
        );

        useEffect(() => {
            const animation = animate(count, valor, {
                duration: 1.2,
                ease: "easeOut",
            });

            return () => animation.stop();
        }, [valor]);

        return <motion.span>{rounded}</motion.span>;
    };


    const cerrarSesion = () => {
        sessionStorage.removeItem("token");

        navigate("/");
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                background:
                    "linear-gradient(135deg, #f5f8f5 0%, #eef4ef 100%)",
                px: { xs: 2, md: 4 },
                py: { xs: 3, md: 5 },
            }}
        >
            <Box
                sx={{
                    maxWidth: 1250,
                    mx: "auto",
                }}
            >
                {/* ENCABEZADO */}
                <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: {
                                xs: "column",
                                sm: "row",
                            },
                            justifyContent: "space-between",
                            alignItems: {
                                xs: "stretch",
                                sm: "center",
                            },
                            gap: 2,
                            mb: 4,
                        }}
                    >

                        {/* SALUDO */}

                        <Box>

                            <Typography
                                variant="h4"
                                sx={{
                                    fontWeight: 800,
                                    color: "#26382b",
                                    mb: 0.5,
                                    fontSize: {
                                        xs: "1.8rem",
                                        md: "2.2rem",
                                    },
                                }}
                            >
                                ¡Hola
                                {usuario?.nombre
                                    ? `, ${usuario.nombre}`
                                    : ""}
                                !
                            </Typography>

                            <Typography
                                sx={{
                                    color: "text.secondary",
                                    fontSize: "1rem",
                                }}
                            >
                                Consulta y administra tus contratos desde aquí.
                            </Typography>

                        </Box>


                        {/* CERRAR SESIÓN */}

                        <Button
                            component={motion.button}
                            whileHover={{
                                scale: 1.05,
                            }}
                            whileTap={{
                                scale: 0.96,
                            }}
                            variant="outlined"
                            color="error"
                            startIcon={<LogoutIcon />}
                            onClick={cerrarSesion}
                            sx={{
                                borderRadius: 2,
                                px: 2.5,
                                py: 1,
                                fontWeight: 600,
                                width: {
                                    xs: "100%",
                                    sm: "auto",
                                },
                            }}
                        >
                            Cerrar sesión
                        </Button>

                    </Box>
                </motion.div>

                {/* TARJETAS DE RESUMEN */}
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: {
                            xs: "1fr",
                            sm: "repeat(2, 1fr)",
                            md: "repeat(3, 1fr)",
                        },
                        gap: 2,
                        mb: 4,
                    }}
                >
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.1 }}
                    >
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2.5,
                                borderRadius: 4,
                                border: "1px solid rgba(81,121,80,.12)",
                                background:
                                    "rgba(255,255,255,.85)",
                            }}
                        >
                            <Stack
                                direction="row"
                                alignItems="center"
                                spacing={2}
                            >
                                <Box
                                    sx={{
                                        width: 48,
                                        height: 48,
                                        borderRadius: 3,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        background:
                                            "rgba(46,184,114,.12)",
                                        color: "#2E8B57",
                                    }}
                                >
                                    <DescriptionOutlined />
                                </Box>

                                <Box>
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                    >
                                        Contratos activos
                                    </Typography>

                                    <Typography
                                        variant="h5"
                                        fontWeight={800}
                                        color="#26382b"
                                    >

                                        <NumeroAnimado valor={contratosActivos} />

                                    </Typography>
                                </Box>
                            </Stack>
                        </Paper>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                    >
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2.5,
                                borderRadius: 4,
                                border: "1px solid rgba(81,121,80,.12)",
                                background:
                                    "rgba(255,255,255,.85)",
                            }}
                        >
                            <Stack
                                direction="row"
                                alignItems="center"
                                spacing={2}
                            >
                                <Box
                                    sx={{
                                        width: 48,
                                        height: 48,
                                        borderRadius: 3,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        background:
                                            "rgba(81,121,80,.10)",
                                        color: "#517950",
                                    }}
                                >
                                    <SavingsOutlined />
                                </Box>

                                <Box>
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                    >
                                        Ahorrador
                                    </Typography>

                                    <Typography
                                        variant="h5"
                                        fontWeight={800}
                                        color="#26382b"
                                    >
                                        <NumeroAnimado valor={contratosAhorro} />
                                    </Typography>
                                </Box>
                            </Stack>
                        </Paper>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.3 }}
                    >
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2.5,
                                borderRadius: 4,
                                border: "1px solid rgba(81,121,80,.12)",
                                background:
                                    "rgba(255,255,255,.85)",
                            }}
                        >
                            <Stack
                                direction="row"
                                alignItems="center"
                                spacing={2}
                            >
                                <Box
                                    sx={{
                                        width: 48,
                                        height: 48,
                                        borderRadius: 3,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        background:
                                            "rgba(46,184,114,.10)",
                                        color: "#1B7F52",
                                    }}
                                >
                                    <TrendingUpOutlined />
                                </Box>

                                <Box>
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                    >
                                        Inversionista
                                    </Typography>

                                    <Typography
                                        variant="h5"
                                        fontWeight={800}
                                        color="#26382b"
                                    >
                                        <NumeroAnimado valor={contratosInversor} />
                                    </Typography>
                                </Box>
                            </Stack>
                        </Paper>
                    </motion.div>
                </Box>

                {/* CONTRATOS */}
                <motion.div
                    initial={{ opacity: 0, y: 25 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{
                        duration: 0.6,
                        delay: 0.35,
                    }}
                >
                    <Paper
                        elevation={0}
                        sx={{
                            borderRadius: 4,
                            overflow: "hidden",
                            border: "1px solid rgba(81,121,80,.12)",
                            background: "#fff",
                        }}
                    >
                        {/* HEADER */}
                        <Box
                            sx={{
                                px: { xs: 2, md: 3 },
                                pt: 3,
                                pb: 1,
                            }}
                        >
                            <Stack
                                direction={{
                                    xs: "column",
                                    sm: "row",
                                }}
                                justifyContent="space-between"
                                alignItems={{
                                    xs: "flex-start",
                                    sm: "center",
                                }}
                                spacing={2}
                            >
                                <Box>
                                    <Typography
                                        variant="h6"
                                        fontWeight={800}
                                        color="#26382b"
                                    >
                                        Mis contratos
                                    </Typography>

                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        sx={{ mt: 0.5 }}
                                    >
                                        Consulta el estado y detalle de tus
                                        contratos.
                                    </Typography>
                                </Box>

                                <Chip
                                    icon={
                                        <AccountBalanceWalletOutlined
                                            fontSize="small"
                                        />
                                    }
                                    label={
                                        tab === 0
                                            ? "Contratos de Ahorrador"
                                            : "Contratos de Inversionista"
                                    }
                                    sx={{
                                        borderRadius: 2,
                                        backgroundColor:
                                            "rgba(81,121,80,.09)",
                                        color: "#517950",
                                        fontWeight: 600,
                                    }}
                                />
                            </Stack>
                        </Box>

                        {/* TABS */}
                        <Box
                            sx={{
                                px: { xs: 1, md: 3 },
                                mt: 2,
                                borderBottom:
                                    "1px solid rgba(0,0,0,.08)",
                            }}
                        >
                            <Tabs
                                value={tab}
                                onChange={handleChangeTab}
                                variant="fullWidth"
                                sx={{
                                    maxWidth: 600,

                                    "& .MuiTabs-indicator": {
                                        height: 3,
                                        borderRadius: 3,
                                        backgroundColor: "#517950",
                                    },

                                    "& .MuiTab-root": {
                                        minHeight: 54,
                                        fontWeight: 600,
                                        color: "text.secondary",
                                    },

                                    "& .Mui-selected": {
                                        color: "#517950 !important",
                                    },
                                }}
                            >
                                <Tab
                                    icon={<SavingsOutlined />}
                                    iconPosition="start"
                                    label="Ahorrador"
                                />

                                <Tab
                                    icon={<TrendingUpOutlined />}
                                    iconPosition="start"
                                    label="Inversionista"
                                />
                            </Tabs>
                        </Box>
                        <AnimatePresence mode="wait">
                            {tab === 0 ? (
                                <motion.div
                                    key="ahorrador"
                                    initial={{ opacity: 0, x: -20 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    exit={{ opacity: 0, x: 20 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    <TablaAhorrador contratos={contratosAhorrador} />
                                </motion.div>
                            ) : (
                                <motion.div
                                    key="inversionista"
                                    initial={{ opacity: 0, x: 20 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    exit={{ opacity: 0, x: -20 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    <TablaInversionista contratos={contratosInversionista} />
                                </motion.div>
                            )}
                        </AnimatePresence>
                        {/* TABLA */}
                        {/*<TableContainer
                            sx={{
                                overflowX: "auto",
                            }}
                        >
                            <Table
                                sx={{
                                    minWidth: 750,
                                }}
                            >
                                <TableHead>
                                    <TableRow
                                        sx={{
                                            backgroundColor:
                                                "#f8faf8",
                                        }}
                                    >
                                        <TableCell
                                            sx={{
                                                fontWeight: 700,
                                                color: "#526052",
                                            }}
                                        >
                                            Contrato
                                        </TableCell>

                                        <TableCell
                                            sx={{
                                                fontWeight: 700,
                                                color: "#526052",
                                            }}
                                        >
                                            Fecha
                                        </TableCell>

                                        <TableCell
                                            sx={{
                                                fontWeight: 700,
                                                color: "#526052",
                                            }}
                                        >
                                            Monto
                                        </TableCell>

                                        <TableCell
                                            sx={{
                                                fontWeight: 700,
                                                color: "#526052",
                                            }}
                                        >
                                            Estado
                                        </TableCell>

                                        <TableCell
                                            align="right"
                                            sx={{
                                                fontWeight: 700,
                                                color: "#526052",
                                            }}
                                        >
                                            Acciones
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={5}>
                                            <Box
                                                sx={{
                                                    py: 8,
                                                    textAlign: "center",
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        width: 72,
                                                        height: 72,
                                                        mx: "auto",
                                                        mb: 2,
                                                        borderRadius: "50%",
                                                        display: "flex",
                                                        alignItems:
                                                            "center",
                                                        justifyContent:
                                                            "center",
                                                        background:
                                                            "rgba(81,121,80,.08)",
                                                        color: "#517950",
                                                    }}
                                                >
                                                    {tab === 0 ? (
                                                        <SavingsOutlined
                                                            sx={{
                                                                fontSize: 36,
                                                            }}
                                                        />
                                                    ) : (
                                                        <TrendingUpOutlined
                                                            sx={{
                                                                fontSize: 36,
                                                            }}
                                                        />
                                                    )}
                                                </Box>

                                                <Typography
                                                    variant="h6"
                                                    fontWeight={700}
                                                    color="#344434"
                                                >
                                                    No tienes contratos
                                                    registrados
                                                </Typography>

                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    sx={{
                                                        maxWidth: 420,
                                                        mx: "auto",
                                                        mt: 1,
                                                    }}
                                                >
                                                    Cuando tengas contratos
                                                    de{" "}
                                                    {tab === 0
                                                        ? "ahorrador"
                                                        : "inversionista"}
                                                    , aparecerán aquí para que
                                                    puedas consultar su
                                                    información.
                                                </Typography>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>*/}
                    </Paper>
                </motion.div>
            </Box>

            {/* PRIMER ACCESO */}
            <PrimerAccesoModal
                open={mostrarPrimerAcceso}
                onSuccess={passwordActualizada}
            />

            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </Box>
    );
};

export default ClientesHome;